import CONFIG from '../config';


export class ApiService {
    static getChartData = ({category, organization, period}: { category: string, organization?: string, period?: string }) => {

        let url = `${CONFIG.BASE_API_URL}${CONFIG.DATASET_URL}/${category}`;

        if (organization) {
            url += '/' + organization;
            if (period) {
                url += '/' + period;
            }
        }

        return fetch(url)
            .then(response => response.json())
            .then(({url}) => fetch(url))
            .then(response => response.json());
    }
}
